import westernRank  from '../images/resources/western-rank.svg'

const academicResources = [
    {
        id: "western-rank",
        icon: westernRank,
        title: "Western Rank",
        description: "Western Rank is a course review site made for and by UWO students. It is the primary place for students to explore Western courses. Try it out, and help make course selection easier by leaving a review if you are a Western student or alumni.",
        buttonText: "WESTERN RANK",
        link: "https://www.westernrank.com/"
    },
    {
        id: "example1",
        icon: westernRank,
        title: "Example 1",
        description: "Western Rank is a course review site made for and by UWO students. It is the primary place for students to explore Western courses. Try it out, and help make course selection easier by leaving a review if you are a Western student or alumni.",
        buttonText: "PLACEHOLDER TEXT",
        link: ""
    },
    {
        id: "example2",
        icon: westernRank,
        title: "Example 2",
        description: "Western Rank is a course review site made for and by UWO students. It is the primary place for students to explore Western courses. Try it out, and help make course selection easier by leaving a review if you are a Western student or alumni.",
        buttonText: "PLACEHOLDER TEXT",
        link: ""
    },
    {
        id: "example3",
        icon: westernRank,
        title: "Example 3",
        description: "Western Rank is a course review site made for and by UWO students. It is the primary place for students to explore Western courses. Try it out, and help make course selection easier by leaving a review if you are a Western student or alumni.",
        buttonText: "PLACEHOLDER TEXT",
        link: ""
    },
    {
        id: "example4",
        icon: westernRank,
        title: "Example 4",
        description: "Western Rank is a course review site made for and by UWO students. It is the primary place for students to explore Western courses. Try it out, and help make course selection easier by leaving a review if you are a Western student or alumni.",
        buttonText: "PLACEHOLDER TEXT",
        link: ""
    }
]

export default academicResources;